(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sv-early-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-sv-faq-item]').forEach(function (item) {
      if (item.dataset.svReady === 'true') return;
      item.dataset.svReady = 'true';
      var button = item.querySelector('.sv-early-faq__question');
      if (!button) return;
      button.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-early-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function svPad(value) {
      return String(value).padStart(2, '0');
    }

    function svTick(root) {
      var end = new Date(root.getAttribute('data-sv-end')).getTime();
      var diff = end - Date.now();
      if (isNaN(end) || diff < 0) diff = 0;
      var days = root.querySelector('[data-sv-days]');
      var hours = root.querySelector('[data-sv-hours]');
      var mins = root.querySelector('[data-sv-mins]');
      var secs = root.querySelector('[data-sv-secs]');
      if (days) days.textContent = svPad(Math.floor(diff / 86400000));
      if (hours) hours.textContent = svPad(Math.floor((diff % 86400000) / 3600000));
      if (mins) mins.textContent = svPad(Math.floor((diff % 3600000) / 60000));
      if (secs) secs.textContent = svPad(Math.floor((diff % 60000) / 1000));
    }

    document.querySelectorAll('[data-sv-early-count]').forEach(function (root) {
      if (root.dataset.svReady === 'true') return;
      root.dataset.svReady = 'true';
      svTick(root);
      window.setInterval(function () { svTick(root); }, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-listicle-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function svBarInit(root) {
      if (!root || root.dataset.svReady === 'true') return;
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sv-bar-slide]'));
      if (slides.length < 2) return;
      root.dataset.svReady = 'true';
      var index = 0;
      function show(next) {
        slides[index].hidden = true;
        index = (next + slides.length) % slides.length;
        slides[index].hidden = false;
      }
      var prev = root.querySelector('[data-sv-bar-prev]');
      var nextBtn = root.querySelector('[data-sv-bar-next]');
      if (prev) prev.addEventListener('click', function () { show(index - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); });
    }

    function svBarBoot(scope) {
      (scope || document).querySelectorAll('[data-sv-bar]').forEach(svBarInit);
    }

    svBarBoot();
    document.addEventListener('shopify:section:load', function (event) {
      svBarBoot(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-listicle-range"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function svRangeShow(root, handle) {
      root.querySelectorAll('[data-sv-range-item]').forEach(function (item) {
        var itemTab = item.getAttribute('data-sv-range-item') || '';
        item.hidden = handle !== 'all' && itemTab !== handle;
      });
      root.querySelectorAll('[data-sv-range-tab]').forEach(function (tab) {
        var active = tab.getAttribute('data-sv-range-tab') === handle;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function svRangeInit(root) {
      if (!root || root.dataset.svReady === 'true') return;
      var tabs = root.querySelectorAll('[data-sv-range-tab]');
      if (!tabs.length) return;
      root.dataset.svReady = 'true';
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          svRangeShow(root, tab.getAttribute('data-sv-range-tab'));
        });
      });
    }

    function svRangeBoot(scope) {
      (scope || document).querySelectorAll('[data-sv-range]').forEach(svRangeInit);
    }

    svRangeBoot();
    document.addEventListener('shopify:section:load', function (event) {
      svRangeBoot(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-listicle-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-sv-reviews]').forEach(function (viewport) {
      if (viewport.dataset.svReady === 'true') return;
      viewport.dataset.svReady = 'true';
      var dots = viewport.parentElement.parentElement.querySelector('[data-sv-reviews-dots] span');
      if (!dots) return;
      viewport.addEventListener('scroll', function () {
        var max = viewport.scrollWidth - viewport.clientWidth;
        var ratio = max > 0 ? viewport.scrollLeft / max : 0;
        dots.style.transform = 'translateX(' + (ratio * 57) + 'px)';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
